import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text } from '@chatterbug/aaron'

const ActivityTimeInfo = ({ date, duration }) => {
  if (!date) {
    return null
  }
  return (
    <Flex
      mt="1x"
      as="h6"
      variant="text.h6"
      color="gray60"
      fontWeight="normal"
      alignItems="center"
    >
      <Text>{date}</Text>
      {duration && (
        <Text>
          <Text>{`, ${duration} min`}</Text>
        </Text>
      )}
    </Flex>
  )
}

ActivityTimeInfo.propTypes = {
  date: PropTypes.string,
  duration: PropTypes.string,
}

export default ActivityTimeInfo
